import React from "react";
import { motion } from "framer-motion";
import { Cake, Heart, Baby, Sparkles } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { IMAGES } from "@/data/site";
import { Reveal, Kicker } from "./Reveal";
import { openWhatsApp } from "@/lib/wa";

const ICONS = [Cake, Heart, Baby, Sparkles];

export default function Special() {
  const { t } = useLang();
  return (
    <section
      id="special"
      className="relative overflow-hidden bg-[var(--red-dark)] py-24 md:py-36"
      data-testid="special-section"
    >
      <img
        src={IMAGES.spread}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-15"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[var(--red-dark)] via-[var(--red-dark)]/90 to-black/70" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 md:grid-cols-2 md:items-center md:px-10">
        <div>
          <Kicker className="mb-5">{t.specialKicker}</Kicker>
          <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-[var(--text)] md:text-7xl">
            {t.specialTitle} <span className="italic gold-gradient-text">{t.specialTitleEm}</span>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md font-sans text-[15px] leading-relaxed text-[var(--text-2)]">
              {t.specialIntro}
            </p>
            <button
              onClick={() => openWhatsApp(t.waQuote)}
              data-testid="special-quote-btn"
              className="mt-8 bg-[var(--gold)] px-8 py-4 font-sans text-sm font-semibold tracking-wide text-[var(--bg)] transition-transform hover:scale-[1.02]"
            >
              {t.specialCta}
            </button>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {t.events.map((ev, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={ev}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                className="group flex items-center gap-4 border border-[var(--gold)]/25 bg-black/30 p-6 backdrop-blur-sm transition-colors hover:border-[var(--gold)]/60"
                data-testid={`event-${i}`}
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[var(--gold)]/40 text-[var(--gold)] transition-colors group-hover:bg-[var(--gold)] group-hover:text-[var(--bg)]">
                  <Icon size={20} />
                </span>
                <span className="font-serif text-2xl text-[var(--text)]">{ev}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
